import { getCountry, getLanguage, getRegion } from '../modules/i18n';
import { addToTrackingData } from '../modules/tracking';

let internalUser = {};
const cachedStatus = localStorage.getItem('isInternalUser');

if (cachedStatus && cachedStatus === 'true') {
  internalUser = { is_internal_user: true };
}

(async () => {
  const [country, language, region] = await Promise.all([getCountry(), getLanguage(), getRegion()]);
  addToTrackingData({
    event: 'page_data_ready',
    location_country: country.toLocaleLowerCase(),
    location_language: language,
    location_region: region,
    ...internalUser,
  });
})();
